module.exports = "<div class=\"container-full group margin-top-xxl margin-bottom-xxl\">\r\n    <router-outlet></router-outlet>\r\n    <p class=\"text--center\" [ngClass]=\"{'hidden': backBtnHidden}\"><a (click)=\"back()\" class=\"btn btn--text btn--text-no-border\"><span class=\"fa fa-arrow-circle-left\"></span> Back</a></p>\r\n</div> "


//////////////////
// WEBPACK FOOTER
// ./src/ts/Apps/CaseLookup/src/app/app.component.html
// module id = ./src/ts/Apps/CaseLookup/src/app/app.component.html
// module chunks = main